import parseDate from 'date-fns/parse';
import subDays from 'date-fns/subDays';
import addMonths from 'date-fns/addMonths';
import formatDate from 'date-fns/format';

export default function () {
  $('.start-date-helper-today').click(function(e) {
    e.preventDefault();
    setStartDate(new Date());
  });

  $('.end-date-helper-today').click(function(e) {
    e.preventDefault();
    setEndDate(new Date());
  });

  $('.end-date-helper-month').click(function(e) {
    e.preventDefault();
    var months = $(this).data('months');
    var startDate = $('.start-date-input').val();
    var endDate = subDays(addMonths(parseDate(startDate, 'yyyy-MM-dd', new Date()), months), 1);
    setEndDate(endDate);
  });

  function setStartDate(date) {
    $('.start-date-input').val(formatDate(date, 'yyyy-MM-dd'));
  }

  function setEndDate(date) {
    $('.end-date-input').val(formatDate(date, 'yyyy-MM-dd'));
  }
};



// WEBPACK FOOTER //
// ./assets/js/subscriptions/dates.js